var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"no-permission",attrs:{"id":"mw"}},[_c('a-result',{attrs:{"status":"403","title":"","sub-title":"抱歉，您暂无权限查看"},scopedSlots:_vm._u([{key:"extra",fn:function(){return undefined},proxy:true}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }